import React from 'react'

// 想定外のエラーで画面全体が真っ白になってしまうのを防ぐための共通エラーバウンダリ。
// 描画中に例外が発生した場合でも、白紙画面ではなく再読み込みを促す表示にフォールバックする。
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        console.error('画面の描画中にエラーが発生しました:', error, info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className='text-center my-16 mx-4'>
                    <i className='bi bi-exclamation-triangle-fill text-red-500 text-3xl mb-3'></i>
                    <p className='text-gray-600 mb-4'>画面の表示中に問題が発生しました。<br/>お手数ですが、再読み込みをお試しください。</p>
                    <button
                        type="button"
                        className='p-2 px-4 bg-purple-500 text-white rounded-md hover:bg-purple-700 tracking-widest'
                        onClick={() => window.location.reload()}
                    >
                        再読み込み
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary
